<!-- @format -->
@if (articleList && articleList.length) {
	<div class="field-guide-wrapper hmf-mb-m hmf-mb-m-xl">
		<div class="field-guide-header hmf-pl-m-s hmf-px-s hmf-ml-m-s">
			<p>
				{{ chain.aemData.title }}
				@if (chain.chainIdentifierAbbr === 'gg') {
					<span>{{ article }}</span>
				}
			</p>
			<h2>{{ chain.aemData.subText }}</h2>
		</div>
		<div class="field-guide-container hmf-m-m-s">
			<div class="hmf-display-flex hmf-flex-row hmf-pb-m-s hmf-pb-s-xs hmf-px-s">
				@for (article of articleList; track article.url; let i = $index) {
					<div class="field-guide">
						<a [href]="article.url">
							<img
								#img
								(error)="handleImageError(img, i)"
								[sharedUtilsDirectiveCommonLazyLoad]="article.imageUrl"
								alt="" />
							<p>{{ article.title }}</p>
							<div>{{ article.description }}</div>
						</a>
					</div>
				}
			</div>
		</div>
	</div>
}
